import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, Overline } from "./Reveal";
import { Mail, MapPin, Globe } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full bg-transparent border-b border-line py-3 text-bone placeholder:text-mute/50 focus:border-brass focus:outline-none transition-colors";

const OFFICES = [
  { icon: MapPin, label: "Headquarters", value: "11 Prestwich Ave, Nepgen, Mthatha" },
  { icon: Mail, label: "General", value: "info@goosethegander.org" },
  { icon: Globe, label: "Website", value: "www.goosethegander.org" },
];

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error("Please complete all fields.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent. Thank you for reaching out.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" data-testid="contact" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-5">
        <Reveal><Overline>Contact</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
            Talk to the desk.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 space-y-8 border-t border-line pt-10">
            {OFFICES.map((o) => (
              <div key={o.label} className="flex items-start gap-4">
                <o.icon size={18} className="text-brass mt-1 shrink-0" />
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-mute">{o.label}</div>
                  <div className="text-bone mt-1">{o.value}</div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <form data-testid="contact-form" onSubmit={submit} className="space-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <input data-testid="contact-name" className={inputCls} placeholder="Name" value={form.name} onChange={set("name")} />
              <input data-testid="contact-email" type="email" className={inputCls} placeholder="Email" value={form.email} onChange={set("email")} />
            </div>
            <input data-testid="contact-subject" className={inputCls} placeholder="Subject" value={form.subject} onChange={set("subject")} />
            <textarea data-testid="contact-message" rows={5} className={`${inputCls} resize-none`} placeholder="Your message" value={form.message} onChange={set("message")} />
            <button data-testid="contact-submit" type="submit" disabled={submitting} className="font-mono text-xs uppercase tracking-[0.2em] border border-brass text-brass px-8 py-4 hover:bg-brass hover:text-ink transition-colors disabled:opacity-50">
              {submitting ? "Sending…" : "Send message"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
